<template>
    <div>
        <v-dialog
            v-model="dialog"
            width="800"
        >
            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                >
                    {{notification.title}}
                </v-card-title>
                <v-card-text class="pt-4">
                    {{notification.description}}
                    <span
                        v-if="notification.image"
                    >
                        <v-img
                            :src="notification.image"
                        />
                    </span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="dialog = false"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Http from "axios";
    import {API_URL, VERSION} from "../config/config";

    export default {
        name: "MessageNotificationDialog",
        data() {
            return {
                notification: {},
                dialog: false
            }
        },
        props: ['type'],
        mounted() {
            const VERSIONED_API_URL = API_URL + VERSION;
            Http.get(`${VERSIONED_API_URL}/message-notification/list-all?type=${this.type}`).then(response => {
                if (response.data && response.data.title !== undefined) {
                    this.dialog = true;
                    this.notification = response.data;
                }

            });
        }
    }
</script>
